<template>
  <div class="link-sharer text-neutral-800">
    <slot />
    <template v-if="link">
      <div class="mb-4 pr-1">
        <CopyInput
          :link="link"
          @click="$emit('click', { medium: { Icon: 'copy', Name: 'Copy' } })"
        />
      </div>
      <div class="flex flex-wrap justify-around link-sharer-media-container md:justify-start">
        <div
          v-for="medium in media"
          :key="medium.Name"
          class="cursor-pointer medium-button-container text-center mb-5 md:mb-0"
        >
          <button
            class="h-12 w-12 flex mr-1 mb-1 flex-col items-center justify-center bg-newBlue-400 rounded-full md:ml-1 md:mr-9"
            :aria-label="$t('Accessibilty.AriaLabels.ShareLinkVia', { medium: medium.Name })"
            @click="$emit('click', { medium })"
          >
            <OSvg :svg="medium.Icon" class="fill-white w-6" />
          </button>
          <span class="o-caption text-newBlue-400 md:mr-9" v-text="medium.Name" />
        </div>
      </div>
    </template>
    <template v-else>
      <NewButton tag="nuxt-link" :to="loginLink" icon-right="new-chevron-right" color="blue">
        {{ $t('Loyalty.Card.Signup') }}
      </NewButton>
      <i18n tag="p" class="block mt-4 o-body" path="Loyalty.Card.AlreadyAnAccount">
        <template #loginLink>
          <NuxtLink
            :to="loginLink"
          >
            <span class="o-body underline" v-text="$t('Loyalty.Card.Here')" />
          </NuxtLink>
        </template>
      </i18n>
    </template>
  </div>
</template>

<script>
import NewButton from '@/components/NewButton'
import { stripLanguageRegex } from '@/utils/general'
const OSvg = () => import('@/components/OSvg')
const CopyInput = () => import('@/components/CopyInput')

export default {
  name: 'LinkSharer',
  components: {
    OSvg,
    CopyInput,
    NewButton
  },
  props: {
    link: {
      type: String,
      default: ''
    }
  },
  computed: {
    media () {
      return ['whatsapp', 'mail', 'instagram-white', 'facebook-messenger'].map((Icon, i) => ({
        Icon,
        Name: this.$t(`Loyalty.LinkSharing.Media[${i}].Name`)
      }))
    },
    loginLink () {
      const url = this.$route.fullPath.replace(stripLanguageRegex, '')
      return `/login?next=${url}`
    }
  }
}
</script>

<style lang="postcss" scoped>
.link-sharer {
  .medium-button-container:last-child > button {
    @apply mr-0;
  }
}
</style>
